import CoreRichText from './CoreRichText';

export { type CoreRichTextProps } from './CoreRichText';
export default CoreRichText;
